import { render, staticRenderFns } from "./IncentivesHistory.vue?vue&type=template&id=3c783be4"
import script from "./IncentivesHistory.vue?vue&type=script&lang=js"
export * from "./IncentivesHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports